module.exports = __webpack_public_path__ + "static/img/showroom8.fd1d3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom8.png
// module id = 3btM
// module chunks = 2